module.exports = __webpack_public_path__ + "static/media/netstratum.f8f62e21.png";